import { Environment } from "@syncfab/machine";

const environment: any = new Environment()
environment.load()

export { environment }